<template>
  <a-card :bordered="false">
    
    <!-- 上部订单查询 -->
    <div class="table-page-search-wrapper">
      <a-form layout="inline">
        <a-row :gutter="48">
          <a-col :md="8" :sm="24" style="float:left">
            <a-form-item label="客户名称">
              <a-select showSearch v-model="queryParam.businessId" style="max-width: 320px" :filterOption="filterOption" placeholder="请选择" default-value="">
                <a-select-option v-for="(item, index) in businessSelect" :key="index" :value="item.id">{{ item.name }}
                </a-select-option>
              </a-select>
            </a-form-item>
          </a-col>

          <a-col :md="6" :sm="24">
            <a-form-item label="物料名称">
              <a-select showSearch v-model="queryParam.materielId"  style="max-width: 320px"
                :filterOption="filterOption" placeholder="请选择" default-value="">
                <a-select-option v-for="(item, index) in materielSelect" :key="index" :value="item.id">{{ item.name }}
                </a-select-option>
              </a-select>
            </a-form-item>
          </a-col>

          <a-col :md="5" :sm="24">
            <a-form-item label="合同号">
              <a-input v-model.trim="queryParam.contractNo" placeholder="" />
            </a-form-item>
          </a-col>

          <a-col :md="5" :sm="24" style="float:right"> 
            <span class="table-page-search-submitButtons">
              <a-button type="primary" @click="refreshData">查询</a-button>
              <a-button style="margin-left: 8px" @click="() => queryParam = {}">重置</a-button>
            </span>
          </a-col>

          <a-col :md="8" :sm="24">
            <a-form-item label="订单状态">
              <a-select showSearch v-model="queryParam.status"  style="max-width: 320px"
                :filterOption="filterOption" placeholder="请选择" default-value="">
                <a-select-option v-for="(item, index) in orderStatusList" :key="index" :value="item.value">{{ item.name }}
                </a-select-option>
              </a-select>
            </a-form-item>
          </a-col>

          <a-col :md="14" :sm="24">
              <a-form-item label="查询日期">
                <a-date-picker
                  format="YYYY-MM-DD"
                  v-model="queryParam.startDate"
                  placeholder=""
                  :disabledDate="disabledDate"
                />
                至
                <a-date-picker
                  format="YYYY-MM-DD"
                  v-model="queryParam.endDate"
                  placeholder=""
                  :disabledDate="disabledDate"
                />
              </a-form-item>
            </a-col>
        </a-row>
      </a-form>
    </div>

    <!-- 订单列表 -->
    <s-table ref="table" :pageSize="pageSize" size="small" :bordered="config.globlaBordered" :rowKey="(record) => record.id"
      :columns="columns" :data="loadData" :scroll="{ x: 1450,y:600}" 
      :row-selection="{ selectedRowKeys: selectedRowKeys, onChange: onSelectChange,hideDefaultSelections:hideDefaultSelections,type:'radio'  }"
      :pagination="{pageSizeOptions:pageSizeOptionsList,showTotal:total => `共${total}条`}">

      <span slot="serial" slot-scope="text, record, index">{{ index + 1 }}</span>
      <span slot="action" slot-scope="text, record" v-if="record.status !== config.OrderStatus.CANCELED">
        <a-divider type="vertical" v-if='roleId === config.RoleType.SALE_MAN'/>
      </span>

      <span slot="invoiceImg" slot-scope="text, record,index">
        <span><img onclick="window.open(this.src)" v-show="record.invoiceImgId" :src="config.imgApiUrl + record.invoiceImgId" width="60" /> </span>
      </span>
      <span slot="status" slot-scope="text, record, index">
        {{record.status !== config.OrderStatus.CANCELED?"否":"是"}}
        <span class="blacktr" v-if='record.status === config.OrderStatus.CANCELED'></span>
        <span class="removeblacktr" v-if='record.status !== config.OrderStatus.CANCELED'></span>
      </span>
    </s-table>


      <!-- 子订单列表 -->
      <a-table ref="table2" size="small" :bordered="config.globlaBordered" :rowKey="(record) => record.id"
        :columns="detailsColumns" :dataSource="detailsList" :scroll="{ x: 2450}" 
        :pagination="false">
  
        <span slot="detailsStatus" slot-scope="text, record, index">
          {{ getTextByOrderStatus(record.status)}}
          <span class="sub_blacktr" v-if='record.status === config.OrderStatus.CANCELED'></span>
          <span class="sub_removeblacktr" v-if='record.status !== config.OrderStatus.CANCELED'></span>
        </span> 

        <template slot="orderOperation" slot-scope="text, record, index" >
            <template v-if='roleId === config.RoleType.SALE_MAN'>
              <a v-if='record.status === config.OrderStatus.FINISHED' @click="changeDetailsStatus(record, config.OrderStatus.WAIT_INVOICE, '提交')">提交</a>
              <a v-if='record.status === config.OrderStatus.INVOICED' @click="changeDetailsStatus(record,config.OrderStatus.INVOICE_FINISHED,'收票')">收票</a>
            </template>
            <template v-if='roleId === config.RoleType.FINANCE'>
              <a v-if='record.status === config.OrderStatus.WAIT_INVOICE' @click="changeDetailsStatus(record,config.OrderStatus.INVOICED,'开票')">开票</a>
              <a-divider type="vertical" v-if='record.status === config.OrderStatus.WAIT_INVOICE' />
              <a-dropdown v-show="record.status === config.OrderStatus.WAIT_INVOICE">
                <a class="ant-dropdown-link">
                  更多
                  <a-icon type="down" />
                </a>
                <a-menu slot="overlay">
                  <a-menu-item>
                    <a v-if='record.status === config.OrderStatus.WAIT_INVOICE' @click="handleExport(record)">开票申请单</a>
                  </a-menu-item>
                </a-menu>
              </a-dropdown>
            </template>
        </template>
      </a-table>
  </a-card>
</template>

<script>
  import { STable } from '@/components'
  import { findListByBusinessTypeId, corpBusinessList} from '@/api/basic'
  import { xsOrderPage,changeDetailsStatus } from '@/api/logistics'
  import moment from 'moment'
  import { formatDate } from '../../utils/date.js'
  import Bus from '@/layouts/bus'
  import queryMixin from '@/mixins/queryMixin'
  import { exportMethod } from '@/utils/exportUtil'

  export default {
    name: 'OrderList',
    mixins: [queryMixin],
    components: {
      STable
    },
    data() {
      return {
        // pageSizeOptionsList: ['5','10','20'],
        pageSizeOptionsList: ['5'],
        pageSize: 5,
        materielSelect: null,
        businessSelect: [],
        loadSelect: [],
        description:
          '销售订单管理',
        visible:false,
        orderStatusList: this.config.orderStatusList.slice(5,9),

        roleId: null,
        // 高级搜索 展开/关闭
        advanced: false,
        // 查询参数
        queryParam: {businessId:null, startDate:moment().startOf('month'), endDate:moment(new Date(), 'YYYY-MM-DD')},

        loading: false,
        showLoading: false,

        data: [],
        detailsList: [],
        hideDefaultSelections: true,
      
        // 表头
        columns: [
   /*        {
            title: '#',
            scopedSlots: { customRender: 'serial' }
          }, */
          {
            title: '订单号',
            dataIndex: 'orderNo',
            width: '150px'
          },
          {
            title: '客户名称',
            dataIndex: 'businessName',
           // scopedSlots: { customRender: 'businessName' },
            /*  width: '140px' */
          },
          {
            title: '发票信息',
            width: '100px',
            scopedSlots: { customRender: 'invoiceImg' }
          },
          {
            title: '合同编号',
            dataIndex: 'contractNo',
            width: '160px'
          },
          {
            title: '合同金额',
            dataIndex: 'contractAmount',
            width: '100px'
          },
          {
            title: '付款方式',
            dataIndex: 'paymentType',
            width: '80px'
          },
          {
            title: '是否作废',
            width: '80px',
            scopedSlots: { customRender: 'status' },
          }, 
          {
            title: '作废人',
            dataIndex: 'canceler',
            width: '120px'
          },
          {
            title: '作废时间',
            dataIndex: 'cancelTime',
            width: '160px',
            customRender: text => {
              if (text) {
                const date = new Date(text)
                return formatDate(date, 'yyyy-MM-dd hh:mm:ss')
              }
            }
          },
          {
            title: '操作',
            width: '150px',
            dataIndex: 'action',
            fixed: 'right',
            scopedSlots: { customRender: 'action' }
          }
        ],

        detailsColumns: [
          {
            title: '订单行号',
            dataIndex: 'code',
            width: '80px',
          },
          {
            title: '物料名称',
            dataIndex: 'materielName',
            /*    width: '80px',  */
          },
          {

            title: '订单量(KG)',
            dataIndex: 'orderNum',
            width: '90px',
          },
          {

            title: '发货量(KG)',
            dataIndex: 'scaleNum',
            width: '90px',
          },
          {

            title: '剩余量(KG)',
            dataIndex: 'remainNum',
            width: '90px',
          },
          {
            title: '订单单价',
            dataIndex: 'price',
            width: '90px',
          },
          {
            title: '订单金额',
            dataIndex: 'amount',
            width: '90px',
          },
          {
            title: '订单状态',
            dataIndex: 'status',
            width: '80px',
            scopedSlots: { customRender: 'detailsStatus' },
          },
          {
            title: '是否承运',
            dataIndex: 'isTransport',
            width: '80px',
            customRender: (text, record) => {
              if (text === '1') {
                return '是'
              }
              return '否'
            }
          },
          {
            title: '运输方式',
            dataIndex: 'transportType',
            width: '90px',
          },
          {
            title: '运输地址',
            dataIndex: 'transportAddress',
            width: '200px',
          },
          {
            title: '联系方式',
            dataIndex: 'contact',
            width: '120px',
          },
          {
            title: '交货日期',
            dataIndex: 'deliveryDate',
            width: '160px',
            customRender: text => {
              if (text) {
                const date = new Date(text)
                return formatDate(date, 'yyyy-MM-dd')
              }
            }
          },
          {
            title: '创建时间',
            dataIndex: 'createTime',
            width: '160px',
            customRender: text => {
              if (text) {
                const date = new Date(text)
                return formatDate(date, 'yyyy-MM-dd hh:mm:ss')
              }
            }
          },
          {
            title: '备注',
            dataIndex: 'memo',
            width: '120px',
          },
          {
            title: '审核人',
            dataIndex: 'auditor',
            width: '80px'
          },
          {
            title: '审核时间',
            dataIndex: 'auditTime',
            width: '160px',
            customRender: text => {
              if (text) {
                const date = new Date(text)
                return formatDate(date, 'yyyy-MM-dd hh:mm:ss')
              }
            }
          }, 
          {
            title: '不通过原因',
            dataIndex: 'reason',
            width: '100px'
          },
          {
            title: '作废人',
            dataIndex: 'canceler',
            width: '120px'
          },
          {
            title: '作废时间',
            dataIndex: 'cancelTime',
            width: '160px',
            customRender: text => {
              if (text) {
                const date = new Date(text)
                return formatDate(date, 'yyyy-MM-dd hh:mm:ss')
              }
            }
          },
          {
            title: '操作',
            key: 'orderOperation',
            fixed: 'right',
            scopedSlots: { customRender: 'orderOperation' },
            width: '120px',
          }
        ],
       
        // 加载数据方法 必须为 Promise 对象
        loadData: parameter => {
          this.queryParam.pageType = "2"  // 开票分页查询

          if (this.queryParam.startDate > this.queryParam.endDate){
            this.$message.warning('开始日期不能大于结束日期',3)
            return
          }
          let condition = Object.assign(parameter, this.queryParam)
          if (condition.startDate){
            condition.startDate = formatDate(new Date(condition.startDate), 'yyyy-MM-dd')
          }
          if (condition.endDate){
            condition.endDate = formatDate(new Date(condition.endDate), 'yyyy-MM-dd')
          }
          return xsOrderPage(condition).then(res => {
            return res.data
          })
        },
        loadSelect() {
          new Promise(resolve => {
            const data = findListByBusinessTypeId({"businessTypeId":101}).then(res => {
              return res.data
            })
            resolve(data)
          }).then(res => {
            this.materielSelect = res
          }),
          new Promise(resolve => {
              const data = corpBusinessList({}).then(res => {
                return res.data
              })
              resolve(data)
            }).then(res => {
              this.businessSelect = res
          })
        },

        selectedRowKeys: [],
        selectedRows: [],
        selectRow:null,
        options: {
          alert: {
            show: false,
            clear: () => {
              this.selectedRowKeys = []
            }
          },
          rowSelection: {
            selectedRowKeys: this.selectedRowKeys,
            onChange: this.onSelectChange
          }
        },
        optionAlertShow: true
      }
    },
    created() {
      //this.loadData({})
      this.loadSelect()
      // 初始化查询条件
      this.queryParam = this.queryParam || null
      this.roleId = this.$store.getters.roles
    },

    mounted(){
    },
    methods: {
      moment,
      disabledDate(current) {
        return current && current > moment().endOf('day')
      },

      handleExport(record){
        let paramData = {id: record.id}
        let exportDetail = {
          method: 'POST',
          url: this.config.downloadOrderXsInvoiceUrl,
          fileName: '发票申请单.xlsx',
          data:paramData
        }
        exportMethod(exportDetail)
      },
      refreshData(){
        this.$refs.table.refresh()
        this.selectedRowKeys = []
        this.selectedRows = []
        this.selectRow = null
        this.detailsList = []
      },


      onSelectChange(selectedRowKeys, selectedRows) {
        this.selectedRowKeys = selectedRowKeys
        this.selectRows = selectedRows
        this.selectRow = selectedRows[0]
        this.detailsList = this.selectRow.orderDetailsXsList
      },
    
      getTextByOrderStatus(status){
        for (let i=0; i< this.config.orderStatusList.length; i++){
          let orderStatus = this.config.orderStatusList[i]
          if (orderStatus.value === status ){
            return orderStatus.name
          }
        }
      },
      changeDetailsStatus(record,status,text) {
        var that = this
        this.$confirm({
          title: '提示',
          content: '确定要'+text+'吗?',
          onOk() {
            that.confirmLoading = true
            return changeDetailsStatus({id:record.id,status:status,orderNo:record.orderNo})
              .then(res => {
                if (res.code === '0') {
                  that.detailsList = res.data
                }
              })
              .catch(e => {
                console.log(e)
              })
              .finally(() => {
                that.confirmLoading = false
              })
          },
          onCancel() { }
        })
      },
      
      filterOption(input, option) {
        // 用于下拉列表可搜索
        return option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
      },

      onChange(selectedRowKeys, selectedRows) {
        this.selectedRowKeys = selectedRowKeys
        this.selectedRows = selectedRows
      },
    },
    watch: {}
  }
</script>

<style scoped>
  /deep/ .ant-form-item {
    margin-bottom: 10px;
  }
</style>